module.exports = __webpack_public_path__ + "img/avatar-s-22.7b43ec93.jpg";